import { ShipmentStatus } from '@/types/shipment.types';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

// Development flag to bypass authentication and API calls
export const BYPASS_AUTH = import.meta.env.VITE_BYPASS_AUTH === 'true' || false;

export const ROUTES = {
  LANDING: '/',
  REGISTER: '/register',
  REGISTER_CARRIER: '/register/carrier',
  REGISTER_TENANT: '/register/tenant',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  SHIPMENTS: '/dashboard/shipments',
  CREATE_SHIPMENT: '/dashboard/shipments/create',
  SHIPMENT_DETAILS: (id: string | number) => `/dashboard/shipments/${id}`,
  DRIVERS: '/dashboard/drivers',
  CARRIERS: '/dashboard/carriers',
  MAP: '/dashboard/map',
  DRIVER_TRACKING: '/dashboard/driver-tracking',
  TENANTS: '/dashboard/tenants',
  REPORTS: '/dashboard/reports',
  FINANCE: '/dashboard/finance',
  USERS: '/dashboard/users',
  SETTINGS: '/dashboard/settings',
  SETTLEMENTS: '/dashboard/settlements',
  SETTLEMENT_DETAILS: (id: string | number) => `/dashboard/settlements/${id}`,
  ONBOARDING: '/dashboard/onboarding',
  WALLET: '/dashboard/wallet',
  FULFILLMENT_CENTERS: '/dashboard/fulfillment-centers',
  MANIFESTS: '/dashboard/manifests',
  MANIFEST_DETAILS: (id: string) => `/dashboard/manifests/${id}`,
  FC_DASHBOARD: (nodeId: string) => `/dashboard/fc/${nodeId}`,
  TRIPS: '/dashboard/trips',
  TRIP_DETAILS: (id: string) => `/dashboard/trips/${id}`,
  SUPPORT: '/dashboard/support',
} as const;

/**
 * QuBox support contact channels. WhatsApp / phone are optional — when unset,
 * the support page simply hides that channel. Email always has a default.
 */
export const SUPPORT_CONTACT = {
  email: import.meta.env.VITE_SUPPORT_EMAIL || 'support@qubox.io',
  whatsapp: import.meta.env.VITE_SUPPORT_WHATSAPP || '',
  phone: import.meta.env.VITE_SUPPORT_PHONE || '',
} as const;

export const STATUS_LABELS: Record<ShipmentStatus, string> = {
  [ShipmentStatus.PENDING]:          'قيد الانتظار',
  [ShipmentStatus.OUT_FOR_PICKUP]:   'خرج للاستلام',
  [ShipmentStatus.COLLECTED]:        'تم الاستلام من المرسل',
  [ShipmentStatus.IN_TRANSIT]:       'في الطريق',
  [ShipmentStatus.OUT_FOR_DELIVERY]: 'خرج للتوصيل',
  [ShipmentStatus.DELIVERED]:        'تم التسليم',
  [ShipmentStatus.FAILED]:           'فشل التسليم',
  [ShipmentStatus.CANCELLED]:        'ملغى',
  [ShipmentStatus.RETURNING]:        'قيد الإرجاع',
  [ShipmentStatus.RETURNED]:         'تم الإرجاع للمرسل',
};

export const STATUS_COLORS: Record<ShipmentStatus, string> = {
  [ShipmentStatus.PENDING]:          'bg-gray-100 text-gray-600',
  [ShipmentStatus.OUT_FOR_PICKUP]:   'bg-amber-100 text-amber-700',
  [ShipmentStatus.COLLECTED]:        'bg-blue-100 text-blue-700',
  [ShipmentStatus.IN_TRANSIT]:       'bg-purple-100 text-purple-700',
  [ShipmentStatus.OUT_FOR_DELIVERY]: 'bg-orange-100 text-orange-800',
  [ShipmentStatus.DELIVERED]:        'bg-green-100 text-green-700',
  [ShipmentStatus.FAILED]:           'bg-red-100 text-red-700',
  [ShipmentStatus.CANCELLED]:        'bg-gray-100 text-gray-600',
  [ShipmentStatus.RETURNING]:        'bg-yellow-100 text-yellow-700',
  [ShipmentStatus.RETURNED]:         'bg-gray-100 text-gray-600',
};

export const PAYMENT_TYPE_LABELS: Record<string, string> = {
  cod: 'الدفع عند الاستلام',
  prepaid: 'مدفوع مسبقاً',
};

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  pending: 'قيد الانتظار',
  paid: 'مدفوع',
  partial: 'مدفوع جزئياً',
  failed: 'فشل الدفع',
  refunded: 'مسترد',
};

export const DEFAULT_PAGE_SIZE = 10;
